import { Chip } from "@nextui-org/react";

export default function ReportStatusBadge({ status }) {
  const renderContent = () => {
    switch (status) {
      case "Disimpan":
        return (
          <Chip color="primary" variant="flat" size="sm">
            Disimpan
          </Chip>
        );
      case "Menunggu Persetujuan":
        return (
          <Chip color="warning" variant="flat" size="sm">
            {status}
          </Chip>
        );
      case "Disetujui":
        return (
          <Chip color="success" variant="flat" size="sm">
            {status}
          </Chip>
        );
      case "Ditolak":
        return (
          <Chip color="danger" variant="flat" size="sm">
            {status}
          </Chip>
        );
      default:
        return (
          <Chip color="secondary" variant="flat" size="sm">
            Draft
          </Chip>
        );
    }
  };

  return <>{renderContent()}</>;
}
